module.exports = __webpack_public_path__ + "static/image-a1f5ef9ca78dd99495fa51065f8245ce.jpg";